export default __webpack_public_path__ + "static/media/bg_gelbs.14a824e9.png";